import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, Label, Select, Skeleton } from '@digdir/designsystemet-react';
import { useGetTeamsQuery } from '../../hooks';
import { useSelectedUnitContext } from '../../contexts/selectedUnitContext';
import { SurveyFormCardUtils } from '../../utils/SurveyFormCardUtils/SurveyFormCard.utils';
import classes from './TeamSelect.module.css';

type TeamSelectProps = {
  /** Teamet siden viser, når det står i adressen. Ellers valgt team i appen. */
  value?: number;
  /** Kalles etter at teamet er valgt i resten av appen */
  onChange?: (teamId: number) => void;
};

/** Velger hvilket team siden viser. Samme valg som team-velgeren i resten av appen. */
export const TeamSelect = ({ value, onChange }: TeamSelectProps = {}) => {
  const { t } = useTranslation();
  const id = useId();
  const { selectedTeamId, setSelectedTeamId } = useSelectedUnitContext();
  const { data: teams, isLoading } = useGetTeamsQuery();

  if (isLoading) {
    return <Skeleton variant="rectangle" width={240} height={64} />;
  }

  return (
    <Field className={classes.teamSelect}>
      <Label data-size="sm" htmlFor={id}>
        {t('teamSelector.label')}
      </Label>
      <Select
        id={id}
        value={(value ?? selectedTeamId) || ''}
        onChange={(event) => {
          const teamId = Number(event.target.value);
          SurveyFormCardUtils.removeAllSessionKeys();
          setSelectedTeamId(teamId);
          onChange?.(teamId);
        }}
      >
        <Select.Option value="" disabled>
          {t('teamSelector.selectTeam')}
        </Select.Option>
        {teams?.map((team) => (
          <Select.Option key={team.id} value={team.id}>
            {team.name}
          </Select.Option>
        ))}
      </Select>
    </Field>
  );
};
